<template>
  <div class="videopage photopage">
    <v-menu></v-menu>
    <mode v-if="loadMode"></mode>
    <div class="pagebg">
      <div class="videoage">
        <div class="bread_nav">
          <div class="left bread_item">
            <ul class="left">
              <router-link class="left tagli index" :to="{name:'index'}" tag="li" active-class="active">首页&nbsp; &gt;&nbsp;</router-link>
              <router-link class="left tagli" :to="{name:'pcVideo'}" tag="li" active-class="active">祖师简介</router-link>
            </ul>
            <div class="clear clearfix"></div>
          </div>
          <div class="clear clearfix"></div>
        </div>
        <div class="introduce_main">
          <div class="swiper swiperbox">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in photoList"  v-if="photoList.length>0">
                <div class="swiper_slider_item">
                  <div class="photo">
                    <img :src="item.img" :alt="item.nick_name" :title="item.nick_name">
                  </div>
                  <div class="introduce_box">
                    <div class="name">{{item.nick_name}}</div>
                    <div class="out_scroll">
                      <div class="introduce_txt" :class="{'totalhei':showdoc==1}" v-html="item.describe"></div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next swiper-button-nextright"></div>
          <div class="swiper-button-prev swiper-button-prevleft"></div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
  import mode from '@/components/bg/mode'
  import Swiper from '../../../../public/swiper/swiper-bundle.min';
  export default {
    name: "index",
    components:{
      mode
    },
    data() {
      return {
        loadMode:true,
        photoList:[],
        showdoc:0
      }
    },
    mounted() {
      this.getList()

    },
    methods: {
      getList(){
        let _this=this
        this.$http({
          url: '/Ancestor/list',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {ajax:1}
        }).then((res) => {
          this.loadMode=false
          console.log(res)
          this.loadMode=false
          if(res.data.code==0){

            this.$nextTick(()=>{
              this.photoList=res.data.data
              // this.showdoc=1
              var swiper = new Swiper(".swiperbox", {
                initialSlide :0,		//轮播开始位置
                observer:true,			//轮播元素为内部动态添加必须加此 修改swiper自己或子元素时，自动初始化swiper
                observeParents:true,	//轮播元素为内部动态添加必须加此 修改swiper的父元素时，自动初始化swiper
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              });
              // this.showdoc=1
              if(this.$route.query.id){
                swiper.slideTo(this.$route.query.id)
              }
            })
          }else{
            this.$layer.msg(res.data.msg)

          }
        })
        .catch((error) => {
          // error
          this.loadMode=false
          console.log(error)
        })

      },
    }
  }
</script>

<style scoped lang="scss">
  .out_introduce{
    position: relative;
    overflow: hidden;
    height:calc(100% - 3rem);
  }
  .out_scroll{
    height:100%;
    -webkit-overflow-scrolling: touch;
  }
  /*.introduce_txt::-webkit-scrollbar{display: none}*/
  .videoage{
    width:95rem;
    margin:0 auto 0;
    height:100%;
    padding-left:9rem;
    box-sizing: border-box;
    .bread_nav{
      padding:2rem 0;
      .bread_item{
        height:3rem;
        .tagli{
          height:3rem;
          font-size:1.1rem;
          color:#5f4009;
          line-height: 3rem;
          cursor: pointer;
        }
        .index{
          background:url("../../../assets/images/nav.png")no-repeat left center;
          background-size:1rem auto;
          padding-left:2rem;

        }
      }
    }
    .introduce_main{
      position: relative;
      height:80%;
      /*height:calc(100% - 10rem);*/
      .swiper {
        width: 85%;
        height: 100%;

      }

      .swiper-slide {
        text-align: center;
        font-size: 18px;
        width:80%;
        margin:0 auto;
        background: rgba(201,161,104,0.3);
        .swiper_slider_item{
          /*padding:2rem;*/
          position: relative;
          height:100%;
          box-sizing: border-box;
          .photo{
              width:11rem;
              position: absolute;
              left:2rem;
              top:2rem;
              img{
                width:11rem;
                display: block;
              }
          }
          .introduce_box{
            padding-left:13rem;
            height:100%;
            position: relative;
            -webkit-overflow-scrolling: touch;
            .name{
              text-align: left;
              font-size:2rem;
              color:#5f4009;
              font-weight: bold;
              line-height: 3rem;
              padding:2rem 0 0 2rem;
              box-sizing: border-box;

            }
            .introduce_txt{
              font-size:1.1rem;
              color:#5f4009;
              line-height: 2.5rem;
              padding:1.5rem 2rem;
              height:calc(100% - 7rem);
              /*height:100%;*/
              box-sizing: border-box;
              overflow-y: scroll;
              text-align: left;
              -webkit-overflow-scrolling: touch;
              /*position: absolute;*/
              /*left:0;*/
              /*top:0;*/
            }
            .totalhei{
              font-size:1.1rem;
              color:#5f4009;
              line-height: 2.5rem;
              padding:1.5rem 2rem;
              height:calc(100% - 7rem);
              /*height:100%;*/
              box-sizing: border-box;
              overflow-y: scroll;
              text-align: left;
              -webkit-overflow-scrolling: touch;
              /*position: absolute;*/
              /*left:0;*/
              /*top:0;*/
            }
          }
        }
      }
      .swiper-button-prevleft{
        left:0;
        --swiper-navigation-color: #5f4009;
        --swiper-navigation-size: 4rem;
      }
      .swiper-button-nextright{
        right:0;
        --swiper-navigation-color: #5f4009;
        --swiper-navigation-size: 4rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/introduce/index.vue